import { render, staticRenderFns } from "./operationChangeHistory.vue?vue&type=template&id=98107b7c&scoped=true&"
import script from "./operationChangeHistory.vue?vue&type=script&lang=js&"
export * from "./operationChangeHistory.vue?vue&type=script&lang=js&"
import style0 from "./operationChangeHistory.vue?vue&type=style&index=0&id=98107b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98107b7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
